<template>
    <v-menu
        left
        offset-y
        v-model="menu_status"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                color="primary"
                dark
                v-on="on"
            >
                &nbsp;&nbsp;{{ selectedMenu }}&nbsp;&nbsp;
                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
            </v-btn>
        </template>

        <v-list dense>
            <v-list-tile
                v-for="(item, index) in details_menu"
                :key="index"
                @click="viewPage(item)"
                :title="`View ${item.name}`"
            >
                <v-list-tile-title small>
                    {{ item.name }}
                </v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'CompensationDetailsMenu',

    metaInfo: {
        title: 'Compensation Details Menu',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Compensation Details Menu' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },

    props: {
        userId: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            menu_status: false
        }
    },

    computed: {
        /**
         * Menu items are computed so they react to userId changes
         */
        details_menu () {
            return [
                { id: 1, name: 'Salary & Pay', link: `/compensation/allocation/${this.userId}/salary-history` },
                { id: 2, name: 'Leave Benefits', link: `/compensation/allocation/${this.userId}/leave-benefits` },
                { id: 3, name: 'De Minimis Benefits', link: `/compensation/allocation/${this.userId}/deminimis-benefits` },
                { id: 4, name: 'Fringe Benefits', link: `/compensation/allocation/${this.userId}/fringe-benefits` },
                { id: 5, name: 'Other Benefits', link: `/compensation/allocation/${this.userId}/other-benefits` }
            ]
        },

        /**
         * Current selected menu label
         */
        selectedMenu () {
            const item = this.details_menu.find(x => x.id === this.id)
            return item ? item.name : ''
        }
    },
    methods: {
        viewPage (item) {
            if (!item || !item.link) return

            // Avoid redundant navigation
            if (this.$route.path !== item.link) {
                this.$router.push(item.link)
            }

            this.menu_status = false
        }
    }
}
</script>
